var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskIllustrate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 491.3 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#63737a;}.cls-2{fill:#22272e;}.cls-3{fill:#6dafa7;}.cls-4{fill:#ffe779;}.cls-5{fill:#f4c2c9;}.cls-10,.cls-6,.cls-8{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.74px;}.cls-6{stroke:#63737a;}.cls-7{fill:#282828;}.cls-8{stroke:#282828;}.cls-9{fill:#f8ab5d;}.cls-10{stroke:#6dafa7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M402.88,328,51.67,381.2a13.55,13.55,0,0,1-15.59-12.47l-21-316.3A14.41,14.41,0,0,1,30.47,37.05L382.3,59.5A13.58,13.58,0,0,1,395,71.76l20.16,240.86A14.67,14.67,0,0,1,402.88,328Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.44,327.58,59.56,381A13.55,13.55,0,0,1,44,368.52L22.78,50.77A14.62,14.62,0,0,1,38.37,35.18L391.65,57.63A13.6,13.6,0,0,1,404.33,70.1L424.7,312A14.16,14.16,0,0,1,412.44,327.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M182.38,218.69l-99.33,5.4a5.78,5.78,0,0,1-6-5.4l-5.82-84A5.91,5.91,0,0,1,77,128.49l99.34.63a5.73,5.73,0,0,1,5.82,5.4L188,212.45A5.86,5.86,0,0,1,182.38,218.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M289.2,186.27l-83.13,2.91a5.78,5.78,0,0,1-6-5.41l-3.54-48.42a5.91,5.91,0,0,1,5.82-6.23l83.13.62a6,6,0,0,1,5.82,5.4L294.81,180A5.74,5.74,0,0,1,289.2,186.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M383.34,183.15l-70,2.49a5.77,5.77,0,0,1-6-5.4l-3.53-43.85a5.9,5.9,0,0,1,5.82-6.23l70,.41a6,6,0,0,1,5.82,5.41l3.32,40.93A5.68,5.68,0,0,1,383.34,183.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188.62,300.15,89.28,311a5.76,5.76,0,0,1-6.44-5.41L79.1,251.31a6,6,0,0,1,5.4-6.23l99.55-6.65a5.82,5.82,0,0,1,6.23,5.4L194,293.92A6.28,6.28,0,0,1,188.62,300.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M298.55,298.07l-82.92,9.77a5.76,5.76,0,0,1-6.44-5.4l-6.65-89.57a5.84,5.84,0,0,1,5.4-6.24l83.13-3.95a5.78,5.78,0,0,1,6,5.41l6.65,83.75A5.92,5.92,0,0,1,298.55,298.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M281.3,218.27l-59.64,3.53a2.31,2.31,0,0,0-2.29,2.7l2.71,37a2.39,2.39,0,0,0,2.7,2.28l59.64-5.19a2.41,2.41,0,0,0,2.29-2.7L284,220.56A2.89,2.89,0,0,0,281.3,218.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M391.65,277.5l-70,7.69a5.75,5.75,0,0,1-6.44-5.41l-5.61-72.11a5.83,5.83,0,0,1,5.4-6.23l70-3.33a5.78,5.78,0,0,1,6,5.41l5.61,67.74A5.62,5.62,0,0,1,391.65,277.5Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 137.91,
    y1: 265.86,
    x2: 139.16,
    y2: 281.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 131.26,
    y1: 274.17,
    x2: 145.81,
    y2: 272.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M237.45,282.9c-.41-4.16-3.53-7.48-7.27-7.06s-6.65,4.15-6.23,8.52,3.74,7.48,7.48,7.06C235,290.8,237.66,287.06,237.45,282.9Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 249.51,
    y1: 281.65,
    x2: 288.37,
    y2: 277.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M336,221c-.42-3.95-3.12-6.86-6.44-6.86-3.33.21-5.61,3.54-5.41,7.49.42,3.94,3.12,7.06,6.45,6.85C334.09,228.25,336.37,224.92,336,221Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 346.56,
    y1: 220.35,
    x2: 380.02,
    y2: 218.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M337.83,243.21c-.42-4-3.12-6.86-6.44-6.65s-5.61,3.74-5.41,7.69c.42,3.95,3.33,7.06,6.45,6.65C335.75,250.48,338.25,247.16,337.83,243.21Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 348.22,
    y1: 242.38,
    x2: 381.89,
    y2: 239.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M339.7,265.44c-.42-3.94-3.12-6.85-6.44-6.65s-5.61,3.75-5.41,7.69c.42,3.95,3.33,6.86,6.45,6.65C337.62,272.72,339.91,269.39,339.7,265.44Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 350.09,
    y1: 264.41,
    x2: 383.55,
    y2: 261.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.91,162.16l-13.51.21a2.66,2.66,0,0,1-2.5-2.29l-1-14.13a2.39,2.39,0,0,1,2.49-2.49h13.51a2.66,2.66,0,0,1,2.49,2.28l1,13.93A2.87,2.87,0,0,1,105.91,162.16Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 120.45,
    y1: 143.46,
    x2: 167.21,
    y2: 143.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 121.29,
    y1: 155.51,
    x2: 168.04,
    y2: 155.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M330.14,158.83l-10.6.21a1.77,1.77,0,0,1-1.45-1.24l-1-13.51a1.42,1.42,0,0,1,1.45-1.46h10.6a1.81,1.81,0,0,1,1.46,1.25l1,13.3A1.56,1.56,0,0,1,330.14,158.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 340.12,
    y1: 142.63,
    x2: 374.82,
    y2: 142.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 341.15,
    y1: 153.22,
    x2: 375.65,
    y2: 152.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 319.13,
    y1: 170.47,
    x2: 376.9,
    y2: 169.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M108.19,194.37l-13.51.42a2.5,2.5,0,0,1-2.49-2.29l-1-14.13a2.35,2.35,0,0,1,2.29-2.49l13.51-.42a2.66,2.66,0,0,1,2.49,2.29l1,13.92A2.56,2.56,0,0,1,108.19,194.37Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 122.74,
    y1: 175.25,
    x2: 169.5,
    y2: 174.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 123.57,
    y1: 187.51,
    x2: 170.33,
    y2: 186.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.27,93.79l-70-2.08a4.49,4.49,0,0,1-4.36-4.16l-.83-11a4.41,4.41,0,0,1,4.57-4.78l70,2.91A4.5,4.5,0,0,1,146,78.83L146.85,89A4.54,4.54,0,0,1,142.27,93.79Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 213.14,
    y1: 143.04,
    x2: 279.23,
    y2: 142.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 213.97,
    y1: 154.68,
    x2: 280.06,
    y2: 153.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 215.22,
    y1: 172.97,
    x2: 250.75,
    y2: 172.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381.26,92.75c-.2-3.12-2.49-5.82-5.19-6-2.5-.2-4.57,2.5-4.16,5.61.21,3.33,2.5,6,5.2,6C379.6,98.57,381.47,95.87,381.26,92.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.77,92.13c-.21-3.33-2.7-6-5.2-6-2.7-.21-4.57,2.49-4.36,5.82s2.7,6,5.4,6C361.1,97.94,363,95.24,362.77,92.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343.65,91.29c-.21-3.32-2.7-6-5.4-6.23s-4.78,2.49-4.58,5.82,2.7,6,5.41,6.23C342,97.32,343.86,94.62,343.65,91.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M465.64,120l-92.27-1.66a7.07,7.07,0,0,1-7.07-6.65L358,10a5.67,5.67,0,0,1,6-6l92.69,9.77a7.13,7.13,0,0,1,6.44,6.65l8.11,93.31A5.63,5.63,0,0,1,465.64,120Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M470.62,118.31l-92.27-1.66a7.06,7.06,0,0,1-7.06-6.65L363,8.38a5.67,5.67,0,0,1,6-6l92.69,9.77a7.12,7.12,0,0,1,6.44,6.65l8.1,93.31A5.75,5.75,0,0,1,470.62,118.31Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 403.29,
    y1: 21.26,
    x2: 452.13,
    y2: 25.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 404.12,
    y1: 31.24,
    x2: 452.96,
    y2: 35.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 405.99,
    y1: 54.1,
    x2: 455.04,
    y2: 57.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 406.82,
    y1: 63.86,
    x2: 455.66,
    y2: 66.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 408.9,
    y1: 86.93,
    x2: 457.74,
    y2: 89.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 409.73,
    y1: 96.7,
    x2: 458.57,
    y2: 98.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "386.46 26.87 388.95 29.99 392.49 25.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "389.16 60.12 391.65 63.03 395.39 58.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "391.86 92.75 394.56 95.66 398.1 90.67"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIllustrate);
export default __webpack_public_path__ + "static/media/task-illustrate.82400a23f201444ae79a1ceb4377bf10.svg";
export { ForwardRef as ReactComponent };